
import React, { Component } from 'react';
import { Modal, Form, Input, Row } from 'antd';

import http from '../../../axios/http';
import messager from '../../ui/messager';

class TradeDeductionCancelForm extends Component {

    //回退申请但状态
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            values["applicationId"] = this.props.applicationId;
            http.post({
                url: '/tradeDeduction/cancelTradeDeduction',
                data: values,
                success: (res) => {
                    messager.notify("撤单成功！");
                    this.props.onCancel();
                    this.props.successCallback(this.props.queryData);
                }
            });
        });

    }

    render() {
        const { visible, onCancel, form } = this.props;
        const { getFieldDecorator } = form;
        return (
            <Modal
                width={400}
                centered={true}
                visible={visible}
                title="其他业务撤单"
                okText="撤单"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                }}
            >
                <Row>
                    <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                        <Form.Item label="撤单理由：">
                            {getFieldDecorator('cancelRemark', {
                                "rules": [
                                    { required: true, message: '撤单理由不能为空!' },
                                ]
                            })(<Input.TextArea />)}
                        </Form.Item>
                    </Form>
                </Row>
            </Modal>
        )
    }
}


const TradeDeductionCancel = Form.create()(TradeDeductionCancelForm);

export default TradeDeductionCancel;